import { render, staticRenderFns } from "./ClientsNav.vue?vue&type=template&id=d50c3390"
import script from "./ClientsNav.vue?vue&type=script&lang=js"
export * from "./ClientsNav.vue?vue&type=script&lang=js"
import style0 from "./ClientsNav.vue?vue&type=style&index=0&id=d50c3390&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports